import { render, staticRenderFns } from "./AlertTitle.vue?vue&type=template&id=6446bc77&"
import script from "./AlertTitle.vue?vue&type=script&lang=js&"
export * from "./AlertTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports